import React from 'react';
import { useTranslation } from 'react-i18next';
import type { KeySearchMode } from './KeySearchModeSwitcher';

export interface KeySearchInstructionsProps {
  mode: KeySearchMode;
}

function KeySearchInstructions({ mode }: KeySearchInstructionsProps) {
  const { t } = useTranslation();

  if (mode === 'tag') {
    return (
      <div className="key-search-instructions text-muted">
        <h3 className="h6 text-white mb-3">{t('Search by tag')}</h3>
        <p className="mb-2">
          {t(
            'Find keys that share the same tag value. Tags are matched across all key providers.'
          )}
        </p>
        <p className="mb-0">
          {t('Enter the tag, then select Search.')}
        </p>
      </div>
    );
  }

  return (
    <div className="key-search-instructions text-muted">
      <h3 className="h6 text-white mb-3">{t('Search by key')}</h3>
      <p className="mb-2">
        {t(
          'Look up one or more keys across all key providers. Results show which provider each key belongs to.'
        )}
      </p>
      <p className="mb-0">
        {t(
          'Enter a single key, or paste multiple keys with one key per line, then select Search.'
        )}
      </p>
    </div>
  );
}

export default KeySearchInstructions;
